import { useCallback, useState } from 'react';
import { getSessionStorageItem, setSessionStorageItem } from '@/utils/session';

const readTimestamp = (key: string): number | null => {
  const value: unknown = getSessionStorageItem(key);
  return typeof value === 'number' && Number.isFinite(value) && value >= 0 ? value : null;
};

export const useSessionTimestamp = (key: string) => {
  const [stored, setStored] = useState(() => ({ key, timestamp: readTimestamp(key) }));
  if (stored.key !== key) {
    setStored({ key, timestamp: readTimestamp(key) });
  }

  const recordNow = useCallback(() => {
    const timestamp = Date.now();
    setSessionStorageItem(key, timestamp);
    setStored({ key, timestamp });
  }, [key]);

  const isWithin = (maxAgeMs = Infinity): boolean => {
    if (stored.timestamp === null) {
      return false;
    }
    const age = Date.now() - stored.timestamp;
    return age >= 0 && age < maxAgeMs;
  };

  return { timestamp: stored.timestamp, isWithin, recordNow: recordNow };
};
